import React, { useState } from "react";
import "./Moderation.css";
import { useConfig } from './ConfigContext';
import GetAccessToken from "./Tokens";

const Moderation = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const config = useConfig();
    const moderationServiceUrl = config?.moderation_url;

    const checkEmail = async () => {
        setMessage("Checking...");
        let access_token = await GetAccessToken(config["user_service_url"]);
        try {
            const response = await fetch(moderationServiceUrl + "/check", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${access_token}`},
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            setMessage(data.message);
        } catch (error) {
            setMessage("Error checking email.");
        }
    };

    const addEmail = async () => {
        setMessage("Adding...");
        let access_token = await GetAccessToken(config["user_service_url"]);
        const pin = Math.floor(10000 + Math.random() * 90000).toString();

        try {
            const response = await fetch(moderationServiceUrl + "/add", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${access_token}`},
                body: JSON.stringify({ email, pin })
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(`Email added successfully. Generated PIN: ${pin}`);
            } else {
                setMessage(`Error: ${data.message}`);
            }
        } catch (error) {
            setMessage("Error adding email.");
        }
    };

    const deleteEmail = async () => {
        setMessage("Deleting...");
        let access_token = await GetAccessToken(config["user_service_url"]);
        try {
            const response = await fetch(moderationServiceUrl  + "/delete", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${access_token}`},
                body: JSON.stringify({ email })
            });
            const data = await response.json();
            setMessage(data.message);
        } catch (error) {
            setMessage("Error deleting email.");
        }
    };

    return (
        <div className="moderation-section">
            <h2>Email Moderation</h2>
            <div className="moderation-form">
                <label htmlFor="email">Email:</label>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <div className="moderation-buttons">
                    <button className="check" onClick={checkEmail}>
                        Check
                    </button>
                    <button className="add" onClick={addEmail}>
                        Add
                    </button>
                    <button className="delete" onClick={deleteEmail}>
                        Delete
                    </button>
                </div>
                {message && <p className="moderation-message">{message}</p>}
            </div>
        </div>
    );
};

export default Moderation;
